import * as React from "react";
import { sanitize } from "../utils/sanitize";

interface ErrorProps {
  errorCode: string;
}

export default function Error({ errorCode }: ErrorProps) {
  return (
    <div
      className="form-general-error message danger"
      dangerouslySetInnerHTML={{ __html: sanitize(i18n[errorCode]) }}
    />
  );
}
